import { render, staticRenderFns } from "./FormChangePasswordAuthUser.vue?vue&type=template&id=0311e4c6"
import script from "./FormChangePasswordAuthUser.vue?vue&type=script&lang=js"
export * from "./FormChangePasswordAuthUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports